import { axiosInstance } from "../client";
import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { PaginationParams } from "@rumble-it/common-lib/types/api/PaginationParams.interface";
import { Log } from "@rumble-it/common-lib/types/models/Log.interface";

interface LogFilterParams {
  "usage[dossier]"?: string;
}

export interface LogQueryParams extends PaginationParams, LogFilterParams {}

export const fetchLogs = async (
  params: LogQueryParams,
): Promise<CollectionResponse<Log>> =>
  axiosInstance
    .get(`/admin/logs`, { params })
    .then((response) => response.data);
